import { Button } from '@mui/material';
import { type FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { isEmptyObject } from '@vy/utils';
import { useFetchXeroSettings } from '../hooks/useFetchXeroSettings';
import { useModifyConfiguration } from '../../../quickbooks-components/configure-quickbooks-integration/hooks/useModifyConfiguration';
import type { XeroConfigurationFormValues } from '../XeroConfigurationFormSchema';
import { getXeroIntegrationSettings } from './utils';
import { useIntegrationContextProvider } from '../../../../hooks/use-integration-context-provider';

export const XeroConfigurationFooter: FC = () => {
  const { integrationId } = useFetchXeroSettings();
  const updateXeroConfiguration = useModifyConfiguration();
  const { clearSelectedIntegration } = useIntegrationContextProvider();

  const {
    handleSubmit,
    formState: { dirtyFields },
    reset,
  } = useFormContext<XeroConfigurationFormValues>();

  const { syncCustomer: _syncCustomer, ...formDirtyValues } = dirtyFields;

  const getUpdateXeroConfigurationPromise = async (formValues: XeroConfigurationFormValues) => {
    if (isEmptyObject(formDirtyValues)) {
      return undefined;
    }

    const updatedIntegrationSettings = getXeroIntegrationSettings(formValues);

    return updateXeroConfiguration(integrationId, updatedIntegrationSettings);
  };

  const submitHandler = handleSubmit(async (formValues) => {
    await getUpdateXeroConfigurationPromise(formValues);

    reset(formValues);

    clearSelectedIntegration();
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button variant="contained" onClick={submitHandler} disabled={isEmptyObject(formDirtyValues)}>
        Save Configuration
      </Button>
    </div>
  );
};
